import type { SVGProps } from "react";

const svgProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
} as const;

export const AiReviewedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...svgProps} {...props}>
    <path d="M3 8V7c0-2.2 1.8-4 4-4h1M16 3h1c2.2 0 4 1.8 4 4v1M21 16v1c0 2.2-1.8 4-4 4h-1M8 21H7c-2.2 0-4-1.8-4-4v-1" />
    <path d="M12 7.5c.32 2.25 2.25 4.19 4.5 4.5-2.25.32-4.19 2.25-4.5 4.5-.32-2.25-2.25-4.19-4.5-4.5 2.25-.32 4.19-2.25 4.5-4.5z" />
  </svg>
);

export const HumanReviewedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...svgProps} {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M14 9.5a2 2 0 1 1-4 0 2 2 0 1 1 4 0z" />
    <path d="M8.5 16c.6-1.8 2-3 3.5-3s2.9 1.2 3.5 3" />
  </svg>
);
